import type { CompleteStoreFragment } from '@drycut/graphql';

import { Navigation } from '@drycut/navigation';
import { ActionButtons, Button, Heading, MobileNavbar, Para, Stack } from '@drycut/ui-components';

type Props = {
  store?: CompleteStoreFragment;
};

export function BookingUnavailable({ store }: Props): React.ReactElement {
  // When this component is rendered because of a failed booking attempt, rather than instead of
  // the booking stepper, it does not receive the store prop.
  const title = `DRYCUT ${store?.name ?? ''}`;

  return (
    <Stack gap={7} className="h-full text-center font-aribau">
      <MobileNavbar title={title} />

      <Stack gap={7}>
        <Heading variant="h2" className="hidden lg:block">
          {title}
        </Heading>

        <Para pretty className="t-2">
          Leider sind für heute keine weiteren Plätze verfügbar. Bitte versuchen Sie es morgen noch
          einmal.
        </Para>
      </Stack>

      <ActionButtons>
        <Button as="a" href={Navigation.HOME_URL}>
          Zur Startseite
        </Button>
      </ActionButtons>
    </Stack>
  );
}
